import type { ReceiptTemplate } from '../schema';

export const albertsonsTemplate: ReceiptTemplate = {
  id: 'albertsons',
  name: 'Albertsons Receipt',
  brand: 'ALBERTSONS',
  description: 'Albertsons grocery store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'alb-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/albertsons.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'alb-store',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'store', label: 'STORE:', value: '#4892' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'alb-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MILK 2% GALLON', quantity: '1', price: '4.99', sku: '' },
          { id: '2', name: 'BREAD WHEAT', quantity: '1', price: '3.49', sku: '' },
          { id: '3', name: 'EGGS LARGE DZ', quantity: '1', price: '5.99', sku: '' },
          { id: '4', name: 'BANANAS', quantity: '1', price: '1.29', sku: '' },
          { id: '5', name: 'CHICKEN BREAST', quantity: '1', price: '8.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'alb-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '24.75', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '0.50', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '25.25', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'alb-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'alb-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'THANK YOU FOR SHOPPING\nAT ALBERTSONS',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

